import apiAdminLib from './lib/apiAdminLib'

function plugin (Vue) {
  if (plugin.installed) {
    return
  }

  const apiAdmin = new Vue({
    methods: apiAdminLib
  })

  Object.defineProperty(Vue.prototype, '$apiAdmin', {
    get () {
      return apiAdmin
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/apiAdmin.js